// extracted by mini-css-extract-plugin
export var domainCard = "domain-card__A6KDQBISjkgqNF_HQz4";
export var verifyDomainContainer = "verify-domain-container_Wu39FR0VGxetWAFE8epr";